import React, { useState, useEffect, lazy, Suspense } from "react";
import {
  Box,
  Grid,
  Typography,
  ListItem,
  IconButton,
  Tabs,
  Tab,
} from "@mui/material";
import { NavLink, Link } from "react-router-dom";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import DyTreeView from "../../components/GlobalComponents/TreeView/TreeView";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { useSelector } from "react-redux";
import { GridRowsProp } from "@mui/x-data-grid";
import { changeTreeViewStateR } from "../Meeting/MeetingsSlice/MeetingsSlice";
import { useDispatch } from "react-redux";
import { resetRValuesR } from "../Meeting/MeetingsSlice/MeetingsSlice";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import LogoutIcon from "@mui/icons-material/Logout";
import CircularProgress from "@mui/material/CircularProgress";
import Timer from "../../components/GlobalComponents/MeetingTimer/MeetingTimer";
// import TeamStatus from './LComponents/TeamStatus/TeamStatus';
import { TabPanelProps } from "./Interfaces/interfaces";
import ObjectiveKeyResults from "./ObjectiveKeyResults/MyObjectiveKeyResults";
import NewTimer from "./new/newTimer";
import AlarmOffIcon from "@mui/icons-material/AlarmOff";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import BAUs from "./BAUs/BAUs";
import TeamStatus from "./LComponents/TeamStatus/TeamStatus";
import PersonStatus from "./LComponents/PersonStatus/PersonStatus";
// import DyTabs from '../../components/GlobalComponents/DyTabs/DyTabs';
// const TeamStatus = lazy(() => import("./LComponents/TeamStatus/TeamStatus"));
const MyCompanyTeams = () => {
  const [tabValue, setTabValue] = React.useState(0);
  const tenantName = useSelector((state: any) => state.meetings.profileName);
  const companyAuth = useSelector(
    (state: any) => state.meetings.teamInfo.isCompany
  );
  const treeView = useSelector(
    (state: any) => state.meetings.treeViewState?.treeView
  );
  const meetSelectedDate = useSelector(
    (state: any) => state.meetings.meetSelectedDate
  );
  const objectivie = useSelector((state: any) => state.meetings.objectivie);
  const teamInfo = useSelector((state: any) => state.meetings.teamInfo);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
  };
  // meetSelectedDate
  const dispatch = useDispatch();

  const [runTimer, setRunTimer] = useState<any>(false);
  const [showTimer, setShowTimer] = useState<boolean>(false);

  const [tabIndex, setTabIndex] = useState(0);

  const initialRunTimer = () => {
    // console.log('run timer')
    setRunTimer(!runTimer);
  };

  const clickInitial = () => {
    dispatch(resetRValuesR());
  };
  var date = new DateObject({ calendar: persian, locale: persian_fa });
  date.calendar = persian;
  date.locale = persian_fa; //جمعه 31 مرداد
  const now = date.format("dddd DD MMMM  ");

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 1 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  const [treeViewVisible, setTreeViewVisible] = useState(true);

  // const toggleTreeView = () => {
  //   setTreeViewVisible((prev) => !prev); // تغییر وضعیت نمایش درخت
  // };
  const toggleTreeView = () => setTreeViewVisible(!treeViewVisible);

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid container sx={{ bgcolor: "#F9F9F9" }}>
          <Grid item xs={12} md={1.5}>
            <Box>
              <ListItem
                onClick={clickInitial}
                sx={{ fontSize: "0.7 rem" }}
                component={Link}
                to={"/dashboard/myMeetings"}
              >
                <Typography
                  display={"flex"}
                  color={"red"}
                  variant="body1"
                  sx={{ fontWeight: 600 }}
                >
                  {" "}
                  <LogoutIcon /> &nbsp;&nbsp; خروج از جلسه{" "}
                </Typography>
              </ListItem>
            </Box>
          </Grid>

          <Grid item xs={12} md={10.5}>
            <Box display={"flex"} flexDirection={"row-reverse"}>
              <NewTimer />
              {/* <div className=" relative cursor-pointer ">
                <button
                  onClick={(e: React.MouseEvent<HTMLElement>) => {
                    e.preventDefault();
                    setShowTimer(!showTimer);
                  }}
                  className={`btn  w-3 text-xs font-thin  btn-sm rounded-md  ml-3`}
                >
                  {!showTimer ? (
                    <AlarmOnIcon />
                  ) : (
                    <div className="w-5 h-5">
                      <AlarmOffIcon />
                    </div>
                  )}
                </button>

                {showTimer && (
                  <div className="absolute mt-0 left-2">
                    <NewTimer />
                  </div>
                )}
              </div> */}
              {/* <Box display={"flex"} alignItems={"center"} pr={2}>
                <Timer />
              </Box> */}
              <Box display={"flex"} alignItems={"center"} mt={0.5}>
                <Typography
                  sx={{ color: "#00387C !important", fontSize: "12px" }}
                  fontWeight={700}
                  px={0.5}
                >
                  شرکت:&nbsp;&nbsp;{tenantName}
                </Typography>
                &nbsp;&nbsp;
                <Typography
                  sx={{ color: "#00387C !important", fontSize: "12px" }}
                  fontWeight={700}
                  px={0.5}
                >
                  جلسه:&nbsp;&nbsp;{meetSelectedDate}
                </Typography>
              </Box>
            </Box>
            <Box></Box>
          </Grid>
        </Grid>
      </Grid>
            <Grid container>
            {treeViewVisible && (
                <Grid item xs={3} md={treeViewVisible ? 1.5 : 0}>
                <Box boxShadow={2} borderRadius={2} mt={2}>
                  <DyTreeView setTabIndex={setTabIndex} onClose={toggleTreeView} />
                </Box>
              </Grid>
            )}
        <Grid item xs={treeViewVisible ? 9 : 12} md={treeViewVisible ? 10.5 : 12}>
        <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>

        {!treeViewVisible && (
                <IconButton
                  size="small"
                  onClick={toggleTreeView}
                >
                  <AccountTreeIcon />
                </IconButton>
              )}
              <Tabs
                value={tabValue}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  label="اهداف و نتایج کلیدی (OKR)"
                  {...a11yProps(0)}
                  style={{ color: "black", fontWeight: "700" }}
                />
                <Tab
                  label="پایش شاخصها (BAU)"
                  {...a11yProps(1)}
                  style={{ color: "black", fontWeight: "700" }}
                />
                {/* {companyAuth&& ( */}
                  <Tab
                    label="وضعیت تیم ها"
                    {...a11yProps(2)}
                    style={{ color: "black", fontWeight: "700" }}
                  />
                {/* )} */}
                {/*companyAuth && objectivie?.length > 0 && */(
                  <Tab
                    label="وضعیت همکاران"
                    {...a11yProps(3)}
                    style={{ color: "black", fontWeight: "700" }}
                  />
                )}
              </Tabs>
            </Box>
            {/* <CustomTabPanel value={value} index={0}> */}

            {tabValue === 0 && (
              // <CustomTabPanel value={tabValue} index={0}>
              // <Suspense
              //   fallback={
              //     <Box width={"100%"} pt={5} textAlign={"center"} py={5}>
              //       <CircularProgress />
              //     </Box>
              //   }
              // >
              <ObjectiveKeyResults />
              // </Suspense>
              // </CustomTabPanel>
            )}
             {tabValue === 1 && (
              // <CustomTabPanel value={tabValue} index={0}>
              // <Suspense
              //   fallback={
              //     <Box width={"100%"} pt={5} textAlign={"center"} py={5}>
              //       <CircularProgress />
              //     </Box>
              //   }
              // >
              <BAUs />
              // </Suspense>
              // </CustomTabPanel>
            )}
           {/*companyAuth && */tabValue === 2 && (
              // <CustomTabPanel value={tabValue} index={1}>
              //   <Suspense
              //     fallback={
              //       <Box width={"100%"} pt={5} textAlign={"center"} py={5}>
              //         <CircularProgress />
              //       </Box>
              //     }
              //   >
                  <TeamStatus />
                // </Suspense>
              // </CustomTabPanel>

        //<TeamStatus />
            )}
            {/*companyAuth && */tabValue === 3 && (
              // <CustomTabPanel value={tabValue} index={1}>
              //   <Suspense
              //     fallback={
              //       <Box width={"100%"} pt={5} textAlign={"center"} py={5}>
              //         <CircularProgress />
              //       </Box>
              //     }
              //   >
                  <PersonStatus />
                // </Suspense>
              // </CustomTabPanel>

        //<TeamStatus />
            )}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MyCompanyTeams;
